import { getAuth, signOut as firebaseSignOut } from "firebase/auth";

export default async function signOut(){

    try {

        const auth = getAuth()
        await firebaseSignOut(auth)
        return
        
    } catch (error) {
        throw error
    }
    
}